import axios from 'axios';
import { ProjectDTO } from '../Pages/CommunityOnBoarding/ProjectList';
import { baseURL } from './APIService';

export const getProjects = async () => {
  const response = await axios.get<any>(baseURL + 'projectmanagement/getallprojects');
  return response.data as ProjectDTO[];
};

export const postProject = async (label: string, description: string, tags: string[], users: string[], admins: string[]) => {
  const response = await axios.post(baseURL + 'projectmanagement/createproject', {
    label,
    description,
    tags,
    users,
    admins
  });
  
  return response.data as any;
};

export const postEditProject = async (label: string, description: string, tags: string[], users: string[], admins: string[]) => {
  const response = await axios.post(baseURL + 'projectmanagement/editproject', {
    label,
    description,
    tags,
    users,
    admins
  });
  
  return response.data as any;
};

